import React from 'react';
import { Container, SectionTitle } from '../../components/ui';
import { ImageCarousel } from '../../components/carousel';

// Mock foto toko: nanti ganti dengan foto asli toko Kranggan & HNI
import banner from '../../images/Banner-Aman-Mart-1.png';

const lokasiKranggan = {
  nama: 'Aman Mart Kranggan',
  alamat: 'Kranggan, area sekitar Aman Mart Kranggan',
  mapEmbedUrl: 'https://www.google.com/maps?q=Amanmart%20Kranggan&output=embed',
  mapTitle: 'Lokasi Aman Mart Kranggan',
  // Mock: 3 slide foto toko (bisa diganti dengan foto asli dari folder public atau images)
  fotoToko: [
    { src: banner, alt: 'Toko Aman Mart Kranggan - Tampak 1' },
    { src: banner, alt: 'Toko Aman Mart Kranggan - Tampak 2' },
    { src: banner, alt: 'Toko Aman Mart Kranggan - Tampak 3' },
  ],
};

const lokasiHNI = {
  nama: 'Aman Mart / Amanstore - Plaza HNI',
  alamat: 'Plaza HNI, Jalan Raya Kalimalang – Billymoon, Pondok Kelapa, Duren Sawit, Jakarta Timur',
  mapEmbedUrl: 'https://www.google.com/maps?q=Plaza%20HNI%20Kalimalang%20Jakarta&output=embed',
  mapTitle: 'Lokasi Aman Mart Plaza HNI',
  fotoToko: [
    { src: banner, alt: 'Toko Aman Mart Plaza HNI - Tampak 1' },
    { src: banner, alt: 'Toko Aman Mart Plaza HNI - Tampak 2' },
    { src: banner, alt: 'Toko Aman Mart Plaza HNI - Tampak 3' },
  ],
};

function LokasiBlock({ lokasi }) {
  return (
    <div className="bg-white rounded-2xl shadow-md border border-am-green-50 overflow-hidden">
      {/* Judul & alamat */}
      <div className="p-6 md:p-8 border-b border-am-green-50">
        <h2 className="text-xl md:text-2xl font-bold text-am-text-900">{lokasi.nama}</h2>
        <p className="mt-2 text-am-text-700 text-sm md:text-base">{lokasi.alamat}</p>
      </div>

      {/* Kiri: foto toko | Kanan: peta */}
      <div className="grid grid-cols-1 lg:grid-cols-2">
        {/* Kiri: carousel foto toko */}
        <div className="p-6 md:p-8">
          <p className="text-sm font-semibold text-am-text-700 mb-3">Foto toko</p>
          <div className="h-[220px] sm:h-[260px] lg:h-[300px]">
            <ImageCarousel images={lokasi.fotoToko} intervalMs={4000} aspect="aspect-video" />
          </div>
        </div>

        {/* Kanan: peta lokasi */}
        <div className="p-6 md:p-8 lg:border-l border-am-green-100">
          <p className="text-sm font-semibold text-am-text-700 mb-3">Peta lokasi</p>
          <div className="h-[220px] sm:h-[260px] lg:h-[300px] rounded-xl overflow-hidden shadow-md border border-am-green-100">
            <iframe
              title={lokasi.mapTitle}
              src={lokasi.mapEmbedUrl}
              width="100%"
              height="100%"
              className="block w-full h-full"
              style={{ border: 0 }}
              allowFullScreen=""
              loading="lazy"
              referrerPolicy="no-referrer-when-downgrade"
            />
          </div>
        </div>
      </div>
    </div>
  );
}

export default function Lokasi() {
  return (
    <main className="min-h-screen">
      {/* Hero judul */}
      <section className="py-14 md:py-16 bg-green-to-white-hero">
        <Container>
          <div className="text-center max-w-2xl mx-auto">
            <SectionTitle
              title="Lokasi Kami"
              subtitle="Kunjungi toko Aman Mart di Kranggan dan Plaza HNI."
              align="center"
            />
          </div>
        </Container>
      </section>

      {/* Dua lokasi: Kranggan & HNI Plaza */}
      <section className="py-12 md:py-16 bg-am-green-50/50">
        <Container className="space-y-14 md:space-y-20">
          <LokasiBlock lokasi={lokasiKranggan} />
          <LokasiBlock lokasi={lokasiHNI} />
        </Container>
      </section>
    </main>
  );
}
